import { jsxs as m, jsx as a } from "react/jsx-runtime";
const t = ({ size: z = 24 }) => /* @__PURE__ */ m("svg", { width: z, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1024 1024", children: [
  /* @__PURE__ */ a(
    "path",
    {
      fill: "#8095FF",
      d: "M137.902 0a48.573 48.573 0 0 0-35.589 15.294 53.965 53.965 0 0 0-15.273 35.64v917.412a48.707 48.707 0 0 0 15.273 35.64 49.971 49.971 0 0 0 35.59 15.293h746.336a48.64 48.64 0 0 0 35.59-15.293 50.37 50.37 0 0 0 15.273-35.64V288.717L646.728 0H137.902z"
    }
  ),
  /* @__PURE__ */ a(
    "path",
    {
      fill: "#FFF",
      d: "M138.24 83.451a42.49 42.49 0 1 0 84.977 0 42.49 42.49 0 0 0-84.977 0zm0 169.825a42.49 42.49 0 1 0 84.977 0 42.49 42.49 0 0 0-84.977 0zm0 169.82a42.49 42.49 0 1 0 84.977.134 42.49 42.49 0 0 0-84.977-.133zm0 169.892a42.49 42.49 0 1 0 42.491-42.49 42.424 42.424 0 0 0-42.49 42.495zm0 169.826a42.49 42.49 0 1 0 84.977.133 42.49 42.49 0 0 0-84.977-.133zm0 169.891a42.49 42.49 0 1 0 84.977 0 42.49 42.49 0 0 0-84.977 0zm658.688-509.608a42.49 42.49 0 1 0 84.977.133 42.49 42.49 0 0 0-84.982-.133zm0 169.891a42.49 42.49 0 1 0 42.486-42.49 42.424 42.424 0 0 0-42.491 42.495zm0 169.826a42.49 42.49 0 1 0 84.977.133 42.49 42.49 0 0 0-84.982-.133zm0 169.891a42.49 42.49 0 1 0 84.977 0 42.49 42.49 0 0 0-84.982 0zM631.091 505.754l-225.08-154.599a16.691 16.691 0 0 0-17.817-.798 17.818 17.818 0 0 0-9.314 15.227v308.331a18.022 18.022 0 0 0 9.308 15.293 16.824 16.824 0 0 0 17.818-.865l225.085-155.392a15.36 15.36 0 0 0 7.645-13.634 18.688 18.688 0 0 0-7.645-13.297v-.266z"
    }
  ),
  /* @__PURE__ */ a(
    "path",
    {
      fill: "#FFF",
      d: "M935.102 288.717H697.656c-27.822-.666-50.227-23.076-50.928-50.934V0l288.374 288.717z",
      opacity: 0.4
    }
  )
] });
export {
  t as VideoIcon
};
//# sourceMappingURL=VideoIcon.js.map
